import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { __ } from '../../translations';
import h from '../../helpers/common';
import { closeSecondaryProductBanner } from '../../store/reducers/profileSlice';

const SecondaryProductWarning = ({ rebranding }) => {
    const isSecondaryProductOpen = useSelector((state) => state.profile.isSecondaryProductOpen);
    const dispatch = useDispatch();
    const closeSecondaryProductBannerData = useCallback(() => dispatch(closeSecondaryProductBanner()), [dispatch]);

    return (
        <div
            className="settings-warning migration-warning"
            style={
                isSecondaryProductOpen
                    ? { opacity: 1, transform: 'translateY(0px)' }
                    : { opacity: 0, transform: 'translateY(400px)' }
            }
        >
            <div>
                {rebranding.migrationBannerImage && (
                    <span className="settings-warning-icon migration-warning">
                        <img src={rebranding.migrationBannerImage} alt="" />
                    </span>
                )}

                <p className="settings-warning-desc migration-warning ">
                    <strong>{__('migration_title')}</strong>
                    <span>{__('migration_subtitle')}</span>
                </p>
            </div>
            <button
                className={'migration-btn'}
                onClick={(e) => {
                    rebranding.secondaryProductUrl &&
                        window.open(
                            h.getLang()
                                ? `${rebranding.secondaryProductUrl}/${h.getLang()}`
                                : rebranding.secondaryProductUrl,
                            '_blank'
                        );
                }}
            >
                {__('migration_cta')}
            </button>

            <div className="warning-close migration-warning">
                <span
                    className="icon-close"
                    onClick={(e) => {
                        closeSecondaryProductBannerData();
                        // eslint-disable-next-line no-undef
                        if (typeof $zopim !== 'undefined' && $zopim !== undefined) {
                            // eslint-disable-next-line no-undef
                            $zopim(function () {
                                // eslint-disable-next-line no-undef
                                $zopim.livechat.button.show();
                            });
                        }
                    }}
                />
            </div>
        </div>
    );
};
export default SecondaryProductWarning;
